import axios from 'axios';
// const baseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
const baseURL = process.env.REACT_APP_API_BASE_URL || "https://environaturesolution.com";

export default axios.create({
  baseURL,
});

export const apiUrl = baseURL;
